<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('clients.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/user'"
        :reloadData="reloadData"
        :createStatus="false"
        :excelFields="excelFields"
        excelName="clients"
      />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import ClientFilter from "../models/ClientFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      filter: new ClientFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "name", label: this.$t("table.name"), sortable: true },
        { key: "image", label: this.$t("global.profileImage"), type: "image" },
        { key: "email", label: this.$t("global.email"), sortable: true },
        { key: "phone", label: this.$t("global.phone"), sortable: true },
        {
          key: "birthdate",
          label: this.$t("global.birthDate"),
          type: "date",
          sortable: true,
        },
        { key: "gender", label: this.$t("global.gender"), sortable: true },
        {
          key: "created_at",
          label: this.$t("table.createdAt"),
          type: "dateTime",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "clients.clientView",
              routeParams: ["id"],
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("table.name")]: "name",
        [this.$t("global.email")]: "email",
        [this.$t("global.phone")]: "phone",
        [this.$t("global.birthDate")]: "birthdate",
        [this.$t("global.gender")]: "gender",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  mounted() {
    core.index();
  },
};
</script>
